export default __webpack_public_path__ + "static/android_manager_app-737ec28f149d566fb533e9e73c082905.png";